import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../services/client.service';
import { Client } from '../../shared/client/client.model';
import { Globals } from '../../global';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.css']
})
export class ClientsComponent implements OnInit {
  client: Client = new Client();
  public data:any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  public sortBy: string = "";
  public sortOrder: string = "desc";
  public event: any;
  public clientToDelete: string;

  constructor(public clientService: ClientService, private globals: Globals) {}

  create() {
    console.log("CREATE");
		console.log(this.client);

		const body = {
			name: this.client.name,
			contactName: this.client.contactName,
			contactPhone: this.client.contactPhone,
			contactEmail: this.client.contactEmail
		}
		
		this.clientService.create(body)
			.subscribe((data:any) => {
				console.log(data);
				if (data.success === true) {
          console.log(data.data);
          document.querySelector("#"+this.event).classList.remove('md-show');
          this.getAll();
				} else {}
			})
  }

  getAll() {
    this.clientService.getAll()
      .subscribe((data:any) => {
        this.data = data.data;
      })
  }

  getByUser() {
    const body = {
      id: JSON.parse(localStorage.getItem('user')).data.id
    }
    this.clientService.getByUser(body)
      .subscribe((data:any) => {
        this.data = data.data;
      })
  }

  delete() {
		document.querySelector("#confirmation").classList.remove('md-show');
	}

  confirmDelete(id) {
		this.clientToDelete = id;
		document.querySelector("#confirmation").classList.add('md-show');
	}

  ngOnInit() {
    if (this.globals.role == 'root' || this.globals.role == 'admin') {
      this.getAll();
    } else {
      this.getByUser();
    }
  }

  openMyModal(event) {
    document.querySelector("#"+event).classList.add('md-show');
    this.event = event;
  }

  closeMyModal(event) {
    ((event.target.parentElement.parentElement).parentElement).classList.remove('md-show');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/clients/clients.component.ts